module.exports = __webpack_public_path__ + "static/media/email-icon.896fafe4.svg";